// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"GHXPr","inputField":"kwLxj","cmOperator":"oP3C0","cmMetricToken":"niWkW","cmErrorUnderline":"yctEN","cmErrorTooltip":"GfJIi","codeEditor":"ChkBJ"};